import splicegroupParcel from './splicegroupParcel'
import create from './create'

const state = {
  inProgressList: [],
}

const getters = {
  // 是否可用
  isAvailable (state, getters, rootState) {
    return rootState.userData.hasJyorder >= 10 || rootState.userData.uid === '1000'
  }
}

const mutations = {
  setInProgressList (state, inProgressList) {
    state.inProgressList = inProgressList
  },
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/splicegroup/v1frontend/splicegroup/search', { params })
  },
  searchHistory ({ state, commit, rootState }, params) {
    return rootState.axios.get('/splicegroup/v1frontend/splicegroup/search-history', { params })
  },
  prepare ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splicegroup/v1frontend/splicegroup/prepare', params)
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splicegroup/v1frontend/splicegroup/create', params)
  },
  cancel ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splicegroup/v1frontend/splicegroup/cancel', params)
  },
  parcels ({ state, commit, rootState }, params) {
    return rootState.axios.get('/splicegroup/v1frontend/splicegroup/parcels', { params })
  },
  searchInprogress ({ state, commit, rootState }, params) {
    return rootState.axios.get('/splicegroup/v1frontend/splicegroup/search-inprogress', { params }).then(res => {
      commit('setInProgressList', res.data.list)
      return res
    })
  },
  join ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splicegroup/v1frontend/splicegroup/join', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    splicegroupParcel,
    create,
  }
}
